/** Performance tab (#310): speed test and connection capacity side by side —
 *  one measures the connection now, the other says how it has actually
 *  behaved. A member checking "is it slow, or is it me" wants both in one
 *  glance. Collapses to a single column below md — two heatmap columns on a
 *  phone would be ~180px each and unreadable. */
import { SimpleGrid } from "@mantine/core";
import { SpeedTestCard } from "@/components/network/speed-test-card";
import { CapacityCard } from "@/components/network/capacity-card";
import { errorStatus } from "@/components/network/shared";
import { useNetworkInfo } from "@/hooks/use-network-queries";

export default function NetworkPerformanceTab() {
  const netQuery = useNetworkInfo();
  const net404 = errorStatus(netQuery.error) === 404;

  return (
    <SimpleGrid cols={{ base: 1, md: 2 }}>
      <SpeedTestCard />
      <CapacityCard hasNetwork={!net404} />
    </SimpleGrid>
  );
}
